var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from 'src/ui/components/Table/Table';
import { CaseItem } from 'src/ui/views/cases/sections/CasesTable/CaseItem';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import styles from './casesTable.module.scss';
import { LoadingTableItem } from 'src/ui/components/Table/LoadingTableItem';
export var CasesTable = function (props) {
    var i18n = props.i18n, columns = props.columns, cases = props.cases, currentSort = props.currentSort, isLoading = props.isLoading, onCaseClick = props.onCaseClick, onHeadClick = props.onHeadClick;
    var handleItemClick = function (caseItem) {
        onCaseClick(caseItem);
    };
    if (cases.length === 0 && !isLoading) {
        return (_jsx("div", __assign({ className: styles.placeholderWrapper }, { children: _jsx("p", { children: getPropsByKeyPath(i18n, 'components.listRest.noResults') }) })));
    }
    if (columns.length === 0) {
        return (_jsx("div", __assign({ className: styles.placeholderWrapper }, { children: _jsx("p", { children: getPropsByKeyPath(i18n, 'components.caseList.emptyList') }) })));
    }
    return (_jsx(Table, { collection: cases, columns: columns, currentSort: currentSort, onHeadClick: onHeadClick, itemRender: function (caseItem) {
            return isLoading ? (_jsx(LoadingTableItem, { nbOfValues: columns.length + 1 })) : (_jsx(CaseItem, { i18n: i18n, content: caseItem.values, isLocked: caseItem.isLocked, lockedBy: caseItem.lockedBy, onClick: function () { return handleItemClick(caseItem); } }));
        } }));
};
